import { render } from "./vlabelmanageadd.vue?vue&type=template&id=069c6472&scoped=true"
import script from "./vlabelmanageadd.vue?vue&type=script&lang=js"
export * from "./vlabelmanageadd.vue?vue&type=script&lang=js"

import "./vlabelmanageadd.vue?vue&type=style&index=0&id=069c6472&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069c6472"]])

export default __exports__